import React, { ReactNode, useEffect, useState } from 'react'
import CustomTable from '../../CustomTable'
import { useSelector } from 'react-redux';
import CouponConfigurableLabel from '../../CouponConfigurableLabel';
import { Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import DoneIcon from '@mui/icons-material/Done';
import { generateRowsMarketDetails } from './service';

/**
 * This component renders the table of selected values from both the location and outlet filter
 * @param props 
 * @returns 
 */
function SelectedMarketDetails(props:any) {
    const { handleRowEdit,handleRowDelete, editingRow , tabsList} = props;
    const [rows, setRows] = useState<Array<Array<string | ReactNode>>>([]);
    const [columns, setColumns] = useState<Array<{ label: string | ReactNode, dataIndex: string, style?: object }>>([]);
    const { schemeLocationBifurcationsList , schemeOutletBifurcationsList } = useSelector((state: any) => state?.manageCoupons?.data)
    
    const generateColumns = async () => {
        const width = (100 / tabsList.length +1) + '%';
        const col = tabsList.map((item:string) => {
            return {
                label: <CouponConfigurableLabel text={item} style={{ color: 'inherit' }} />,
                dataIndex: item,
                style: { minWidth: '160px', width }
            }
        });
        col.push({
            label: <></>,
            dataIndex: undefined,
            style: { minWidth: '0', width }
        });
        setColumns(col);
    }

    const generateRows = async () => {
        const rows = generateRowsMarketDetails(tabsList,schemeLocationBifurcationsList,schemeOutletBifurcationsList);
        const temp: any = [];
        rows.forEach((row: any, idx: number) => {
            temp.push(
                [
                    ... row.map((element:string) => {
                        return <div key={element} className={'custom-table-cell'}>{element.split("*break*").map((str)=><span>{str}</span>)}</div>
                    }),
                <div className='custom-table-cell-action-btn'>
                    <Button onClick={() => handleRowEdit(idx)} size='small'
                        className='sku-group-row-selector-edit-button'
                        startIcon={<DoneIcon />}>
                        Edit
                    </Button>
                    <Button onClick={() => handleRowDelete(idx)} size='small'
                        className='sku-group-row-selector-delete-button'
                        startIcon={ <DeleteIcon />}>
                        Delete
                    </Button>
                </div>
                ])
        })

        setRows(temp);
    }

    const init = async () => {
        await generateRows();
        await generateColumns();
    }

    useEffect(() => {
        init();
    }, [schemeLocationBifurcationsList,schemeOutletBifurcationsList, editingRow])


    return (
        rows.length > 0 ?
            <CustomTable
                rows={rows}
                columns={columns}
                tableContainerProps={{
                    style: {
                        maxHeight: "350px",
                        border: '0.4px solid #1C7EA0',
                        fontFamily:'Poppins'
                    }
                }}
                tableProps={{
                    stickyHeader: true
                }}
                tableHeadProps={{}}
                tableHeadCellProps={{
                    style: {
                        color: 'var(--coupon-dark-blue)',
                        padding: "10px 5px",
                        backgroundColor: 'var(--coupon-light-blue)',
                        fontWeight:'600'
                    }
                }}
                tableRowCellProps={{
                    style: { borderBottom: 'none', padding: '16px 5px' },
                    component: "th",
                    scope: "row"
                }}
            />
            :
            <></>
    )
}

export default SelectedMarketDetails